import React from 'react';
import { AppRoutes } from './app/router/AppRoutes';
import { TurnstileInitializer } from './app/providers/TurnstileInitializer';
import { NotificationsProvider } from './ui/notifications';
import { SiteConfigProvider } from './app/providers/SiteConfigProvider';

export default function App() {
    return (
        <NotificationsProvider>
            <TurnstileInitializer>
                <SiteConfigProvider>
                    <AppRoutes />
                </SiteConfigProvider>
            </TurnstileInitializer>
        </NotificationsProvider>
    );
}
